import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const DentistPortal = () => {
  const [activeTab, setActiveTab] = useState('dashboard');

  const todayAppointments = [
    {
      id: 1,
      time: '09:00 AM',
      patient: 'John Smith',
      type: 'Dental Cleaning',
      status: 'Confirmed'
    },
    {
      id: 2,
      time: '10:30 AM',
      patient: 'Sarah Johnson',
      type: 'Root Canal',
      status: 'In Progress'
    },
    {
      id: 3,
      time: '02:00 PM',
      patient: 'Michael Brown',
      type: 'Crown Fitting',
      status: 'Scheduled'
    }
  ];

  const recentPatients = [
    {
      id: 1,
      name: 'Emily Davis',
      lastVisit: '2024-02-15',
      nextAppointment: '2024-03-20',
      status: 'Active'
    },
    {
      id: 2,
      name: 'Robert Wilson',
      lastVisit: '2024-02-10',
      nextAppointment: '2024-04-05',
      status: 'Active'
    },
    {
      id: 3,
      name: 'Lisa Anderson',
      lastVisit: '2024-01-25',
      nextAppointment: null,
      status: 'Inactive'
    }
  ];

  const renderTabContent = () => {
    switch (activeTab) {
      case 'dashboard':
        return (
          <div className="space-y-6">
            <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
              <div className="bg-white p-6 rounded-2xl shadow-lg">
                <h3 className="text-lg font-semibold text-[#1E2A4A] mb-2">Today's Appointments</h3>
                <p className="text-2xl font-bold text-orange-500">8</p>
                <p className="text-gray-600">3 completed, 5 remaining</p>
              </div>
              <div className="bg-white p-6 rounded-2xl shadow-lg">
                <h3 className="text-lg font-semibold text-[#1E2A4A] mb-2">Active Patients</h3>
                <p className="text-2xl font-bold text-[#1E2A4A]">1,234</p>
                <p className="text-green-600">+12 this month</p>
              </div>
              <div className="bg-white p-6 rounded-2xl shadow-lg">
                <h3 className="text-lg font-semibold text-[#1E2A4A] mb-2">Monthly Revenue</h3>
                <p className="text-2xl font-bold text-[#1E2A4A]">$45,678</p>
                <p className="text-green-600">+8% from last month</p>
              </div>
              <div className="bg-white p-6 rounded-2xl shadow-lg">
                <h3 className="text-lg font-semibold text-[#1E2A4A] mb-2">Pending Tasks</h3>
                <p className="text-2xl font-bold text-[#1E2A4A]">5</p>
                <p className="text-orange-500">2 urgent</p>
              </div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div className="bg-white rounded-2xl shadow-lg p-6">
                <h3 className="text-xl font-bold text-[#1E2A4A] mb-4">Today's Schedule</h3>
                <div className="space-y-4">
                  {todayAppointments.map(appointment => (
                    <div key={appointment.id} className="flex items-center justify-between p-4 bg-gray-50 rounded-xl">
                      <div>
                        <p className="font-semibold text-[#1E2A4A]">{appointment.time}</p>
                        <p className="text-gray-600">{appointment.patient}</p>
                        <p className="text-sm text-gray-500">{appointment.type}</p>
                      </div>
                      <span className={`px-3 py-1 rounded-full text-sm ${
                        appointment.status === 'Confirmed' ? 'bg-green-100 text-green-800' :
                        appointment.status === 'In Progress' ? 'bg-blue-100 text-blue-800' :
                        'bg-yellow-100 text-yellow-800'
                      }`}>
                        {appointment.status}
                      </span>
                    </div>
                  ))}
                </div>
              </div>

              <div className="bg-white rounded-2xl shadow-lg p-6">
                <h3 className="text-xl font-bold text-[#1E2A4A] mb-4">Recent Patients</h3>
                <div className="space-y-4">
                  {recentPatients.map(patient => (
                    <div key={patient.id} className="flex items-center justify-between p-4 bg-gray-50 rounded-xl">
                      <div>
                        <p className="font-semibold text-[#1E2A4A]">{patient.name}</p>
                        <p className="text-sm text-gray-500">Last Visit: {patient.lastVisit}</p>
                        {patient.nextAppointment && (
                          <p className="text-sm text-gray-500">Next: {patient.nextAppointment}</p>
                        )}
                      </div>
                      <span className={`px-3 py-1 rounded-full text-sm ${
                        patient.status === 'Active' ? 'bg-green-100 text-green-800' : 'bg-gray-100 text-gray-800'
                      }`}>
                        {patient.status}
                      </span>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        );
      case 'patients':
        return (
          <div className="bg-white rounded-2xl shadow-lg p-6">
            <div className="flex justify-between items-center mb-6">
              <h3 className="text-xl font-bold text-[#1E2A4A]">Patient Management</h3>
              <button className="bg-orange-500 text-white px-4 py-2 rounded-xl hover:bg-orange-600 transition-colors">
                Add New Patient
              </button>
            </div>
            <div className="mb-6">
              <input
                type="text"
                placeholder="Search patients..."
                className="w-full p-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-orange-500 focus:border-orange-500"
              />
            </div>
            <div className="overflow-x-auto">
              <table className="min-w-full">
                <thead>
                  <tr className="bg-gray-50">
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Name</th>
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Last Visit</th>
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Next Appointment</th>
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Status</th>
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Actions</th>
                  </tr>
                </thead>
                <tbody className="bg-white divide-y divide-gray-200">
                  {recentPatients.map(patient => (
                    <tr key={patient.id}>
                      <td className="px-6 py-4 whitespace-nowrap">
                        <div className="text-sm font-medium text-[#1E2A4A]">{patient.name}</div>
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap">
                        <div className="text-sm text-gray-500">{patient.lastVisit}</div>
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap">
                        <div className="text-sm text-gray-500">{patient.nextAppointment || 'None'}</div>
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap">
                        <span className={`px-2 py-1 text-xs rounded-full ${
                          patient.status === 'Active' ? 'bg-green-100 text-green-800' : 'bg-gray-100 text-gray-800'
                        }`}>
                          {patient.status}
                        </span>
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                        <button className="text-orange-500 hover:text-orange-600 mr-3">View</button>
                        <button className="text-orange-500 hover:text-orange-600">Edit</button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        );
      case 'appointments':
        return (
          <div className="bg-white rounded-2xl shadow-lg p-6">
            <div className="flex justify-between items-center mb-6">
              <h3 className="text-xl font-bold text-[#1E2A4A]">Appointment Management</h3>
              <button className="bg-orange-500 text-white px-4 py-2 rounded-xl hover:bg-orange-600 transition-colors">
                Schedule New
              </button>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Date</label>
                <input type="date" className="w-full p-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-orange-500 focus:border-orange-500" />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Filter by Status</label>
                <select className="w-full p-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-orange-500 focus:border-orange-500">
                  <option value="all">All Appointments</option>
                  <option value="confirmed">Confirmed</option>
                  <option value="pending">Pending</option>
                  <option value="completed">Completed</option>
                </select>
              </div>
            </div>
            <div className="space-y-4">
              {todayAppointments.map(appointment => (
                <div key={appointment.id} className="flex items-center justify-between p-4 bg-gray-50 rounded-xl">
                  <div>
                    <p className="font-semibold text-[#1E2A4A]">{appointment.time}</p>
                    <p className="text-gray-600">{appointment.patient}</p>
                    <p className="text-sm text-gray-500">{appointment.type}</p>
                  </div>
                  <div className="flex space-x-2">
                    <button className="text-orange-500 hover:text-orange-600">Edit</button>
                    <button className="text-red-500 hover:text-red-600">Cancel</button>
                  </div>
                </div>
              ))}
            </div>
          </div>
        );
      default:
        return null;
    }
  };

  return (
    <div className="min-h-screen bg-gray-50 pt-24">
      <div className="container mx-auto px-6 py-8">
        <div className="max-w-6xl mx-auto">
          <div className="flex flex-col md:flex-row justify-between items-start md:items-center mb-8">
            <div>
              <h1 className="text-3xl font-bold text-[#1E2A4A]">Dentist Portal</h1>
              <p className="text-gray-600 mt-2">Welcome back, Dr. Sarah Johnson</p>
            </div>
            <div className="mt-4 md:mt-0">
              <button className="bg-orange-500 text-white px-6 py-3 rounded-xl hover:bg-orange-600 transition-colors">
                Update Profile
              </button>
            </div>
          </div>

          <div className="bg-white rounded-2xl shadow-lg overflow-hidden">
            <div className="border-b border-gray-200">
              <nav className="flex space-x-8 px-6">
                {['dashboard', 'patients', 'appointments'].map((tab) => (
                  <button
                    key={tab}
                    onClick={() => setActiveTab(tab)}
                    className={`py-4 px-1 border-b-2 font-medium text-sm ${
                      activeTab === tab
                        ? 'border-orange-500 text-orange-500'
                        : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                    }`}
                  >
                    {tab.charAt(0).toUpperCase() + tab.slice(1)}
                  </button>
                ))}
              </nav>
            </div>

            <div className="p-6">
              {renderTabContent()}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DentistPortal; 